import { DrawerForm, DrawerSizeEnum } from '@acceso/design-system';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ProgramDrawer } from '@/features/programs/components/ProgramDrawerForm/ProgramDrawer';
import { TProgramForm } from '@/features/programs/types';
import { DrawerFormDataType, FormTypeEnum } from '@/types';

import { useProgramDrawerFormState } from '../../hooks/useProgramDrawerFormState';

type ProgramBroadcastDrawerFormProps = {
  isOpen: boolean;
  data?: DrawerFormDataType<Partial<TProgramForm>> | null;
  onClose: () => void;
  onSubmit: (formData: TProgramForm) => void;
  isMutating: boolean;
};

export function ProgramDrawerForm({
  data,
  isOpen,
  onClose,
  onSubmit,
  isMutating,
}: ProgramBroadcastDrawerFormProps) {
  const { t } = useTranslation();
  const { form } = useProgramDrawerFormState();

  useEffect(() => {
    if (data?.data) {
      form.reset(data?.data);
    }
  }, [data]);

  useEffect(() => {
    if (!isOpen) {
      form.reset();
    }
  }, [isOpen]);

  const handleSubmit = form.handleSubmit(onSubmit);

  return (
    <DrawerForm
      title={
        data?.type === FormTypeEnum.CREATE
          ? t('Crear nuevo programa')
          : data?.type === FormTypeEnum.UPDATE
            ? t('Editar programa')
            : t('Duplicar programa')
      }
      isOpen={isOpen}
      onCancel={onClose}
      onSubmit={handleSubmit}
      size={DrawerSizeEnum.MD}
      isMutating={isMutating}
      labels={{
        submit: t('Guardar'),
        cancel: t('Cancelar'),
      }}
    >
      <ProgramDrawer form={form} isInitializing hideHeader />
    </DrawerForm>
  );
}
